var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scorecardId!=undefined && _vm.displaySoup)?_c('v-icon',{staticClass:"float-right",attrs:{"title":"Open Printable Scorecard in New Tab..."},on:{"click":_vm.openTab}},[_vm._v("mdi-newspaper-variant-multiple-outline")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }